import React from 'react';
import '../styles/PopUp.css';

const PopUp = ({ term, definition, origin, moreDetails, category, handleClosePopUp }) => {
  return (
    <div>
      <h2 className="popup-title">Term: {term}🖊️</h2>
      <p className="popup-text"><b>Definition</b>: {definition}</p>
      <p className="popup-text"><b>Origin</b>: {origin}</p>
      <div className="popup-info">
        <p className="popup-text"><b>Category</b>: {category}</p>
        <p className="popup-text">
          <b>Term Details</b>: <a href={moreDetails} target="_blank" rel="noopener noreferrer">Learn more⭷</a>
        </p>
      </div>
      <button className="popup-button close-button" onClick={handleClosePopUp}>
        Close
      </button>
    </div>
  );
};

export default PopUp;